import React from 'react';
import { Card } from '@/components/ui/card';
import { AssessmentPrompt } from './cards/AssessmentPrompt';
import { AchievementsPanel } from './AchievementsPanel';
import { CareerChat } from './CareerChat';
import { WeeklyGoals } from './cards/WeeklyGoals';
import { AssessmentList } from './AssessmentList';
import { LearningPathPanel } from './LearningPathPanel';
import { ChallengesPanel } from './ChallengesPanel';
import { motion } from 'framer-motion';
import { useAuth } from '@/context/auth';
import { useCareerProgress } from '@/hooks/useCareerProgress';

export function DashboardContent() {
  const { user } = useAuth();
  const { loading: careerLoading, careerCoins, completedGoals } = useCareerProgress();

  if (!user) {
    return null;
  }

  return (
    <div className="space-y-8">
      {/* Assessment Prompt */}
      <AssessmentPrompt />

      {/* Main Grid */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        {/* Left Column */}
        <div className="lg:col-span-2 space-y-6">
          <WeeklyGoals
            goals={[
              {
                id: '1',
                text: 'Complete skill assessment',
                completed: false,
                points: 50
              },
              {
                id: '2',
                text: 'Set career goals',
                completed: false,
                points: 30
              }
            ]}
          />
          <AssessmentList />
          <LearningPathPanel />
        </div>

        {/* Right Column */}
        <div className="space-y-6">
          <AchievementsPanel />
          <ChallengesPanel />
        </div>
      </div>

      {/* AI Career Chat */}
      <Card className="p-6">
        <CareerChat />
      </Card>
    </div>
  );
}